import { SearchSortAndDirection } from '@/types/search/enums/sortTypes';

const DEFAULT_QUERY_PARAMS = {
    country: '',
    page: 1,
    pageSize: 24,
    publishDateMin: '',
    shipping: '',
    sort: SearchSortAndDirection.MostRelevant,
    status: '',
    topRated: '',
};

const normalizeQuery = (query: any = {}, defaults: any = DEFAULT_QUERY_PARAMS) => {
    const newQuery = { ...query };
    Object.keys(query).forEach((prop) => {
        if (`${query[prop]}` === `${defaults[prop]}` || defaults[prop] === undefined) {
            delete newQuery[prop];
        } else if (typeof defaults[prop] === 'number') {
            newQuery[prop] = Number(query[prop]);
        }
    });
    return newQuery;
};

export default normalizeQuery;
